import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { AccountProductTypeMap } from './AccountProductTypeMap';

export default class AccountProductTypesResource extends FBaseService {
  public async get(): Promise<AccountProductTypeMap> {
    const url = '/api/rcx/config/account-product-types';

    const response: AxiosResponse = await this.apiClient.get(url);
    return response.data.data;
  }
}
